import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  navigationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 50
  }
}))